import { OnInit, Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { DialogService } from '../../../dialog/dialog.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { DashboardService } from '../../services/dashboard.service';
// // import { DialogService } from '../../../../Components/dialog/dialog.service';
// import { AlertsService } from '../../../../services/alerts.service';
// import { AppService } from '../../../../services/app.service';
// import { BaseService } from '../../../../services/base.service';
// import { LoaderService } from '../../../../services/loader.service';
// import { StorageService } from '../../../../services/storage.service';
// import { UtilService } from '../../../../services/util.service';

// import { DashboardService } from '../../services/dashboard.service';
// import { CacheService } from '../../../../services/cache.service';

@Component({
    selector: 'app-dashboard-cta',
    templateUrl: './dashboard-cta.component.html',
    styleUrls: ['./dashboard-cta.component.scss'],
    standalone: false
})
export class DashboardCtaComponent implements OnInit {
  @Input() data: any;
  @Output() configChanged: EventEmitter<any> = new EventEmitter();

  config: any = {};
  showSkeletonLoader = true;
  height: string;
  constructor(private appService: AppService,
    private loader: LoaderService,
    public router: Router,
    public dialogService: DialogService,
    public storage: StorageService,
    public alerts: AlertsService,
    public utilService: UtilService,  
    //public cacheService: CacheService,
    public dashBoardService: DashboardService) {

  }


  ngOnInit() {
    this.build();
    if (this.utilService.isMobile()) {
      this.height = '180px'
     } else {
      this.height = '180px'
  
     }

  }


  build() {
    // this.loader.showSpinner();
    let id = this.data.widget_id || this.data.slider_id;

    //if(this.cacheService.checkWidget( 'dashboard_cta', id)) {
    this.dashBoardService.getWidgetData(id, (data) => {
      this.config.data = data;
      //this.cacheService.setWidgetStorage('dashboard_cta', data);
      console.log('this.config.data', this.config.data);
      if (this.utilService.isMobile()) {
        if (data && data.mobile_document_id) {
          this.config.data.bannerUrl = this.utilService.getImageUrl(data.mobile_document_id);
        }
      } else {
        if (data && data.document_id) {
          this.config.data.bannerUrl = this.utilService.getImageUrl(data.document_id);
        }
      }
      // this.loader.hideSpinner();
      this.showSkeletonLoader = false;
    })
  } 
  // else {
  //   this.cacheService.getWidget().subscribe(value => {
  //    const List = value.filter(ele => ele['dashboard_cta']);
  //    const configData = List.filter(ele => ele['dashboard_cta'].id === id)
  //    this.config.data = configData && configData.length > 0 ? configData[0]['dashboard_cta'] : '';
  //     this.showSkeletonLoader = false;

  //   })
  // } 
  //}

  goto(link) {
    this.router.navigateByUrl(link);
  }


}
